import React, { Component } from "react";
import { Formik, Form } from "formik";
import { FormEffect } from "./FormEffect";
import * as Yup from "yup";
import _ from "lodash";

export interface FormWrapperProps {
    initialValues?: any;
    onChange: (...args: any) => any;
    validation: Yup.Schema<any>;
    validateOnUpdate?: boolean;
    fields?: any;
    hasUniqueField?: boolean;
}

export interface FormWrapperState {
    validation: Yup.Schema<any>;
}

const linkedValidations = {
    lessThan: {
        string: fieldName => `Must be < or eq. to ${fieldName}`,
        test: (value, max) => {
            return value <= max;
        }
    },
    exclusiveLessThan: {
        string: fieldName => `Must be < than ${fieldName}`,
        test: (value, max) => {
            return value < max;
        }
    },
    moreThan: {
        string: fieldName => `Must be > or eq. to ${fieldName}`,
        test: (value, max) => {
            return value >= max;
        }
    },
    exclusiveMoreThan: {
        string: fieldName => `Must be > than ${fieldName}`,
        test: (value, max) => {
            return value > max;
        }
    }
};

class FormWrapper extends Component<FormWrapperProps, FormWrapperState> {
    private previousFormValues = null;
    formikForm: React.RefObject<Formik>;

    constructor(props) {
        super(props);

        this.formikForm = React.createRef();

        this.state = {
            validation: this.props.validation
        };
    }

    validateIfHasProperty = (field, property) => {
        if (
            field.validationSchema &&
            field.validationSchema.hasOwnProperty(property)
        ) {
            if (
                this.previousFormValues.hasOwnProperty([
                    field.validationSchema[property]
                ]) &&
                this.previousFormValues[field.validationSchema[property]] !=
                undefined &&
                this.previousFormValues[field.validationSchema[property]] != ""
            ) {
                return true;
            }
        }

        return false;
    };
    concatValidationsSchemas = (initialSchema, field, property) => {
        const index = _.findIndex(
            this.props.fields,
            f => f.name == field.validationSchema[property]
        );
        const linkedField = this.props.fields[index];

        let newValidations = Yup.number().test(
            property,
            linkedValidations[property].string(linkedField.fieldOptions.label),
            val =>
                linkedValidations[property].test(
                    val,
                    this.previousFormValues[field.validationSchema[property]]
                )
        );

        return initialSchema.concat(newValidations);
    };

    onChange = formProps => {
        if (!_.isEqual(formProps.values, this.previousFormValues)) {
            this.previousFormValues = { ...formProps.values };

            let validation = _.cloneDeep(this.props.validation);

            this.props.fields.map(field => {
                Object.keys(linkedValidations).map(property => {
                    if (this.validateIfHasProperty(field, property)) {
                        validation["fields"][field.name] =
                            this.concatValidationsSchemas(
                                validation["fields"][field.name],
                                field,
                                property
                            );
                    }
                });
            });

            this.setState({
                validation: validation
            });

            //console.log(validation.validateSync(this.previousFormValues));
            validation.isValid(this.previousFormValues).then(isValid => {
                return this.props.onChange({
                    values: { ...this.previousFormValues },
                    isValid
                });
            });
        }
    };

    componentDidUpdate(prevProps) {
        if (
            this.props.validateOnUpdate &&
            !_.isEqual(
                prevProps.fields.map(field => field.name),
                this.props.fields.map(field => field.name)
            )
        ) {
            this.state.validation
                .isValid(this.previousFormValues)
                .then(isValid =>
                    this.props.onChange({
                        values: { ...this.previousFormValues },
                        isValid
                    })
                );
        }

        if (this.props.hasUniqueField) {
            this.formikForm.current.validateForm(this.previousFormValues);
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.validateOnUpdate || nextProps.hasUniqueField) {
            return {
                ...prevState,
                validation: nextProps.validation
            };
        }

        return null;
    }

    render() {
        return (
            <Formik
                onSubmit={() => { }}
                ref={this.formikForm}
                initialValues={this.props.initialValues || {}}
                enableReinitialize={
                    this.props.initialValues.hasOwnProperty("type") &&
                    (this.props.initialValues.type == "fractionated" ||
                        this.props.initialValues.type == "easylink" ||
                        this.props.initialValues.type == "multipots" ||
                        this.props.initialValues.type == "jumbolink" ||
                        this.props.initialValues.type == "luckytokenslink" ||
                        this.props.initialValues.type == "reelstrike" ||
                        this.props.initialValues.type == "levels" ||
                        this.props.initialValues.type == "sap" ||
                        this.props.initialValues.type == "mr_champion" ||
                        this.props.initialValues.type == "pig_boom")
                }
                validationSchema={this.state.validation}
                render={formProps => {
                    return (
                        <React.Fragment>
                            <FormEffect
                                {...formProps}
                                onChange={this.onChange}
                            />

                            {this.props.children}
                        </React.Fragment>
                    );
                }}
            />
        );
    }
}
export default FormWrapper;
